// Bridges an arbitrary CSS color string (hsl/hsla/rgb/rgba/#hex/#rrggbbaa/
// named colors) to a {hex, alpha} pair a native <input type="color"> +
// <input type="range"> pair can edit, and back again. Uses the browser's
// own color parser via getComputedStyle rather than a hand-rolled one, so
// every syntax CSS accepts is supported for free.
function toRgbString(cssColor) {
    const el = document.createElement('div');
    el.style.color = cssColor;
    document.body.appendChild(el);
    const rgb = getComputedStyle(el).color;
    document.body.removeChild(el);
    return rgb;
}

export function parseCssColor(cssColor) {
    if (!cssColor) return { hex: '#000000', alpha: 1 };
    const rgb = toRgbString(cssColor);
    const match = rgb.match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/);
    if (!match) return { hex: '#000000', alpha: 1 };
    const [, r, g, b, a] = match;
    const toHex = (n) => Math.round(Number(n)).toString(16).padStart(2, '0');
    return {
        hex: '#' + toHex(r) + toHex(g) + toHex(b),
        alpha: a !== undefined ? Number(a) : 1,
    };
}

export function formatCssColor(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    if (alpha >= 1) return `rgb(${r}, ${g}, ${b})`;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
